module.exports = __webpack_public_path__ + "static/media/flight-loading.68025e4e.gif";